import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPropertyAmenityCategory.ts
var t = () => e("propertyAmenityCategory");
//#endregion
export { t as useTrPropertyAmenityCategory };
